import { useChatContext } from './useChatContext';

/**
 * The experience this chat makes or edits. A chat bound to one before its
 * first turn (quick edits, or a printable opened from the library) has no
 * `chat.experienceId` until the server row lands, so the binding stands in.
 * Surfaces with no ChatContextProvider (the extension and the share page) get
 * the fallback context, which has no `chat`.
 */
export const useChatExperienceId = (): string | undefined => {
  const { chat, experienceId } = useChatContext();
  return chat?.experienceId ?? experienceId;
};
